// extracted by mini-css-extract-plugin
export default {"list":"NGjo1","icon":"o8Lv6","skeleton-progress":"_-3cbS"};